<div class="dialog-wrapper">
  <!-- Head -->
  <div class="head">
    <label class="label-title">Send Test</label>
    <!-- <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
      <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
    </button> -->
  </div>
  <!-- Body -->
  <div class="body">
    <p class="typo pt-20 pb-20 body-1 fw400 semi-condensed label-message">Specify the recipient email you want to send the test</p>
    <form class="form-wrapper">
      <div class="form-content">
        <div class="form-section">
          <div class="form-section-container padding nopadding">
            <mat-form-field class="size size1of1" appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput  [formControl]='emailFormControl' >
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="nav">
    <div class="inner">
      <button mat-flat-button (click)="onClose()" color="secondary" class="mat-button custom-mat-button-primary">Cancel</button>
      <button mat-flat-button [disabled]="emailFormControl.invalid" (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">Send</button>
    </div>
  </div>
</div>
